{
    "bannerImgs": ["oliebollen.png"]
}
